var AdvisoryPresenter = /** @class */ (function () {
    function AdvisoryPresenter(advisoryUsecases) {
        this.advisoryUsecases = advisoryUsecases;
    }
    AdvisoryPresenter.prototype.syncNuvamaPortfolio = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.advisoryUsecases.syncNuvamaPortfolio.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    AdvisoryPresenter.prototype.getCasUploadSummary = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.advisoryUsecases.getCASUploadSummary.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    AdvisoryPresenter.prototype.getCASUploadHistory = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.advisoryUsecases.getCASUploadHistory.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    AdvisoryPresenter.prototype.uploadCASpdf = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.advisoryUsecases.uploadCAS.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    return AdvisoryPresenter;
}());
export default AdvisoryPresenter;
